/**
 * Rebuild the browser's native selection after comment highlighting wraps the
 * selected text in one or more <mark> elements. Without this, the DOM surgery
 * collapses the drag selection and the user's next Cmd/Ctrl+C copies nothing.
 *
 * The document and Selection parameters are injectable so this small but
 * fiddly browser contract can be unit-tested without a DOM emulator.
 */
export function preserveCommentSelection(
  prose: HTMLElement,
  commentId: string,
  selection: Selection | null = window.getSelection(),
  ownerDocument: Pick<Document, 'createRange'> = document,
): boolean {
  const marks = Array.from(prose.querySelectorAll<HTMLElement>('mark[data-comment-id]')).filter(
    (mark) => mark.dataset.commentId === commentId,
  )
  if (!selection || marks.length === 0) return false

  const range = ownerDocument.createRange()
  range.setStartBefore(marks[0])
  range.setEndAfter(marks[marks.length - 1])
  selection.removeAllRanges()
  selection.addRange(range)
  return true
}
